<ng-template #otpNotReceivedModal let-modal>
    <div class="modal-header">
        <h4 class="modal-title" id="modal-basic-title">Didn’t Get Your OTP?</h4>
        <button type="button" class="btn-close" aria-label="Close" title="Close Modal" (click)="modal.dismiss('Cross click')"
            title="Close Modal"></button>
    </div>
    <div class="modal-body">
        <form>

            <h5 class="modal-info-text light">We apologize that you didn’t get your OTP. Please check your Spam box just
                in
                case.</h5>
            <h5 class="modal-info-text light">
                Click on the button below for us to send you another OTP
            </h5>
            <input type="hidden" name="Resend" value="test">
            <div class="btn-grps mt-0">

                <app-button [btnType]="'submit'" [isFocus]="true" [btnText]="'Resend OTP'" [btnTitle]="'Resend OTP'"
                    [isDisable]="isDisableResendBtn" [btnCss]="'btn btn-primary w-100 btn-lg'"
                    (onBtnClick)="onResendOTPClick()" tabindex="0"></app-button>
                <app-button [btnText]="'Cancel'" [btnTitle]="'Cancel'" [btnCss]="'btn btn-text w-100 btn-md'"
                    (onBtnClick)="modal.dismiss('Cross click')"></app-button>
            </div>
        </form>

    </div>
</ng-template>